import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";

const NOTIFICATION_TIME = "NOTIFICATION_TIME";
const SILENT_NOTIFICATION = 7;

export const useRequestNotificationPermission = () => {
  const [permission, setPermission] = useState<NotificationPermission>();

  const isNotificationAvailable = useCallback(() => "Notification" in window, []);

  const handleRequestPermission = useCallback(() => {
    if (isNotificationAvailable())
      Notification.requestPermission()
        .then(() => {
          setPermission(Notification.permission);
        })
        .catch((ex) => {
          console.log(ex.message);
          setPermission("denied");
        });
  }, [isNotificationAvailable]);

  const handleRejectPermission = useCallback(() => {
    if (isNotificationAvailable()) {
      setPermission("denied");
      // set date in days from canceling date in localstorage and only show notification request if time is
      // after the one in localstorage
      localStorage.setItem(NOTIFICATION_TIME, dayjs().add(SILENT_NOTIFICATION, "days").toString());
    }
  }, [isNotificationAvailable]);

  const getPersistedNotificationValue = useCallback(() => localStorage.getItem(NOTIFICATION_TIME), []);
  const setPersistedNotificationValue = useCallback(
    (value: string) => localStorage.setItem(NOTIFICATION_TIME, value),
    []
  );

  useEffect(() => {
    if (isNotificationAvailable()) setPermission(Notification.permission);
  }, [isNotificationAvailable]);

  return {
    permission,
    requestPermission: handleRequestPermission,
    rejectPermission: handleRejectPermission,
    getPersistedNotificationValue,
    setPersistedNotificationValue,
    isNotificationAvailable,
  };
};
